module.exports = __webpack_public_path__ + "img/stock2.d53bb646.png";